import * as angular from 'angular';
import {IController} from "angular";
import {DateRangeTemplateType} from "../../types/date-range-template.type";

export class DateRangeTemplateTypeSelectSectionComponent implements IController {
  dateRangeTemplateType: DateRangeTemplateType;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.values(DateRangeTemplateType);
    }
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('dateRangeTemplateTypeSelectSection', {
    bindings: {
      dateRangeTemplateType: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./date-range-template-type-select-section.html').default,
    controller: DateRangeTemplateTypeSelectSectionComponent
  });
